<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title"><strong>ALTERAR PARCELAS</strong></h3>
  </div>

  <form
    [formGroup]="alterarValorForm"
    class="forms modal-alterar-valor"
    (ngSubmit)="onPersonalizarParcela()"
  >
    <div class="modal-body">
      <div class="inputs">
        <h4 class="modal-alterar-valor-label" for="valorFinanciamento">
          Opções disponíveis
        </h4>
        <select
          formControlName="quantidadeParcelas"
          name="quantidadeParcelas"
          appShowErrorMessages
          requiredMessage="Selecione a quantidade de parcelas"
          class="form-control"
        >
          <option *ngFor="let item of parcelasPersonalizada" value="{{ item }}">
            {{ item }}x
          </option>
        </select>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="bt-back btn btn-border-orange" (click)="close()">
        Fechar</button
      >
      <button type="submit" class="bt-go btn btn-full-orange">
        Salvar
      </button>
    </div>
  </form>
</div>
